import { j as jsxRuntimeExports } from "./doenetml-CDvV96YD.js";
import React__default from "react";
import { u as useDoenetRenderer } from "./useDoenetRenderer-YzDSBjpZ.js";
const ellipsis = React__default.memo(function Ellipsis(props) {
  let { id, SVs } = useDoenetRenderer(props);
  if (SVs.hidden) {
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx("span", { id, children: "…" });
});
export {
  ellipsis as default
};
